import { render, staticRenderFns } from "./dadosGerais.vue?vue&type=template&id=6fb445e3"
import script from "./dadosGerais.vue?vue&type=script&lang=js"
export * from "./dadosGerais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports